"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFilterOption = void 0;
var _fuzzysort = _interopRequireDefault(require("fuzzysort"));
var _selectV = require("../../selectV2");
var _optionToString = require("./optionToString");
const getFilterOption = useFuzzySearch => {
  return (opt, input, fuzzySearchScoreMap) => {
    const searchString = (0, _optionToString.optionToFilterString)(opt);
    if (useFuzzySearch) {
      const result = _fuzzysort.default.single(input, searchString);
      if (result) {
        if (fuzzySearchScoreMap) {
          fuzzySearchScoreMap.set(opt, result.score);
        }
        return result.score >= _selectV.FUZZYSORT_MIN_THRESHOLD;
      }
      return false;
    } else {
      return searchString.includes(input.toLocaleLowerCase());
    }
  };
};
exports.getFilterOption = getFilterOption;
//# sourceMappingURL=getFilterOption.js.map